import axios from "@/services/api-client";
import {
  CreateVariableRequest,
  UpdateVariableRequest,
  VariableKind,
  VariablePublic,
  VariableSource,
  VariableValueType,
  VaultTestRequest,
  VaultTestResult,
} from "./variableShape";

// Re-export under the legacy ``Workflow*`` names so existing call sites keep
// working without churn. The shape itself is shared with the workspace
// service — see ``./variableShape.ts``.
export type WorkflowVariableKind = VariableKind;
export type WorkflowVariableValueType = VariableValueType;
export type WorkflowVariableSource = VariableSource;
export type WorkflowVariablePublic = VariablePublic;
export type CreateWorkflowVariableRequest = CreateVariableRequest;
export type UpdateWorkflowVariableRequest = UpdateVariableRequest;

function base(groupId: string, workflowId: string): string {
  return `/api/backend/groups/${groupId}/workflows/${workflowId}/variables`;
}

export const WorkflowVariablesService = {
  async list(
    groupId: string,
    workflowId: string
  ): Promise<WorkflowVariablePublic[]> {
    const res = await axios.get<{
      variables: WorkflowVariablePublic[];
    }>(base(groupId, workflowId));
    return res.data.variables;
  },

  async create(
    groupId: string,
    workflowId: string,
    req: CreateWorkflowVariableRequest
  ): Promise<WorkflowVariablePublic> {
    const res = await axios.post<WorkflowVariablePublic>(
      base(groupId, workflowId),
      req
    );
    return res.data;
  },

  async update(
    groupId: string,
    workflowId: string,
    variableId: string,
    req: UpdateWorkflowVariableRequest
  ): Promise<WorkflowVariablePublic> {
    const res = await axios.patch<WorkflowVariablePublic>(
      `${base(groupId, workflowId)}/${variableId}`,
      req
    );
    return res.data;
  },

  async remove(
    groupId: string,
    workflowId: string,
    variableId: string
  ): Promise<void> {
    await axios.delete(`${base(groupId, workflowId)}/${variableId}`);
  },

  async testVault(
    groupId: string,
    workflowId: string,
    req: VaultTestRequest
  ): Promise<VaultTestResult> {
    const res = await axios.post<VaultTestResult>(
      `${base(groupId, workflowId)}/test-vault`,
      req
    );
    return res.data;
  },
};
